export enum Pages {
  STATISTICS = 'STATISTICS',
  ORDERS = 'ORDERS',
  ORDER = 'ORDER',
  ClIENTS = 'ClIENTS',
  EMPOLOYEES = 'EMPOLOYEES',
  ROLES = 'ROLES',
  FILIALS = 'FILIALS',
  TYPES_PAYMENT = 'TYPES_PAYMENT',
  SERVICE = 'SERVICE'
}

export const AllPages = [
  // {
  //   name: 'Статистика',
  //   id: Pages.STATISTICS
  // },
  // {
  //   name: 'Заказ',
  //   id: Pages.ORDER
  // },
  {
    name: 'Оформления заказа',
    id: Pages.ORDER
  },
  {
    name: 'Список заказов',
    id: Pages.ORDERS
  },
  {
    name: 'Пациенты',
    id: Pages.ClIENTS
  },
  {
    name: 'Сотрудники',
    id: Pages.EMPOLOYEES
  },
  {
    name: 'Роли',
    id: Pages.ROLES
  },
  {
    name: 'Филиялы',
    id: Pages.FILIALS
  },
  {
    name: 'Тип оплат',
    id: Pages.TYPES_PAYMENT
  },
  {
    name: 'Услуги',
    id: Pages.SERVICE
  }
]
